import {
  MessageSessionType,
  MessageType,
} from '@pages/agent/InboxPage/components/MessageView/types/message';

const mockedMessages: MessageType[] = [
  {
    content: 'Hello, how can I help you?',
    sender: 'Agent Smith',
    agentId: 'agent-1',
    createdAt: '2021-09-01T10:00:00Z',
    id: 1,
  },
  {
    content: 'I have a problem with my order.',
    sender: 'John Doe',
    createdAt: '2021-09-01T10:01:00Z',
    id: 2,
  },
  {
    content:
      'Sorry to hear that. Can you please provide me with your order number?',
    sender: 'Agent Smith',
    agentId: 'agent-1',
    createdAt: '2021-09-01T10:02:00Z',
    id: 3,
  },
  {
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    sender: 'John Doe',
    createdAt: '2021-09-01T10:03:00Z',
    id: 4,
  },
  {
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    sender: 'Agent Smith',
    agentId: 'agent-1',
    createdAt: '2021-09-01T10:03:00Z',
    id: 5,
  },
];

export const mockedMessageSession: MessageSessionType[] = [
  {
    id: '120',
    messages: mockedMessages,
    startedAt: '2021-06-01T10:00:00Z',
  },
  {
    id: '121',
    messages: mockedMessages,
    startedAt: '2021-07-01T10:00:00Z',
  },
  {
    id: '122',
    messages: mockedMessages,
    startedAt: '2021-08-01T10:00:00Z',
  },
  {
    id: '123',
    messages: mockedMessages,
    startedAt: '2021-09-01T10:00:00Z',
  },
];
